import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  content: {
    containerName: 'sf-main-dialog',
    containerType: 'inline-size',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    color: neutral[100],
    '@media (width >= 45rem)': {
      flexDirection: 'row',
    },
  },

  // Order Detail
  orderDetail: {
    flex: '1 1 auto',
    width: '100%',
    padding: '0.5rem 1rem 1rem 1rem',
    overflowY: 'auto',
    '@container sf-main-dialog (width >= 45rem)': {
      flex: '1 1 auto',
      minWidth: '22.5rem',
      padding: '0.5rem 1rem 1.5rem 1.5rem',
    },
  },
  odHeader: {
    padding: '0.25rem 0',
    marginBottom: '0.5rem',
    '& > h1': {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: '2rem',
    },
    '& > p': {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: neutral[80],
    },
  },
  products: {
    padding: '1rem 0',
    '& > [aria-label="form-group"]': {
      display: 'flex',
      gap: '1rem',
      flexDirection: 'column',
    },
  },
  divider: {
    borderTop: `1px solid ${neutral[20]}`,
  },
  // --- orderDetail

  flow: {
    flex: '1 1 auto',
    position: 'relative',
    height: '100%',
    width: '100%',
    maxWidth: '100%',
    padding: '0.5rem 1rem 1rem 1rem',
    display: 'flex',
    gap: '1rem',
    flexDirection: 'column',
    '@container sf-main-dialog (width >= 45rem)': {
      flex: '23.5rem 0 22.5rem',
      maxWidth: '23.5rem',
      padding: '0.5rem 1rem',
    },
  },
  flowHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    paddingTop: '0.25rem',
    backgroundColor: neutral.white,
    '& > h1': {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: '2rem',
    },
    '& > p': {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: neutral[80],
      '& > span': {
        fontWeight: 600,
      },
    },
  },
  flowMain: {
    flex: '1 1 auto',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  flowFooter: {
    position: 'sticky',
    bottom: 0,
    zIndex: 1,
    padding: '1rem 0',
    backgroundColor: neutral.white,
  },
  ctaBtn: {
    padding: '0.75rem 1rem',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    borderRadius: '0.5rem',
    color: neutral.white,
    backgroundColor: neutral[90],
    border: `1px solid ${neutral[100]}`,
    '&:hover': {
      color: neutral['20'],
      backgroundColor: neutral[100],
    },
  },
});
